const isTextEllipsisShown = (elementQuerySelector) => {
  const tooltipTargetElement = document.querySelector(elementQuerySelector)

  return tooltipTargetElement && (tooltipTargetElement.offsetWidth < tooltipTargetElement.scrollWidth ||
    tooltipTargetElement.offsetHeight < tooltipTargetElement.scrollHeight)
}

export default isTextEllipsisShown
